module.exports = __webpack_public_path__ + "static/img/EF.0f30692.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/EF.png
// module id = MJlw
// module chunks = 34